import React from 'react';
import { Text, TextVariant } from '@naf/text';
import styled from '@emotion/styled';
import { TextList, TextListItem } from '@naf-simba/elements-textlist';

import { CenterArticleType } from '@appTypes/centerArticleType';
import S from '../styles';

const StyledTextList = styled(TextList)`
  max-width: 512px;
`;

export const CenterInformation = ({ title, additionalInformation }: Partial<CenterArticleType>) => (
  <S.InformationWrapper>
    <Text variant={TextVariant.Header3}>Informasjon om {title}</Text>
    <StyledTextList variant="dotted">
      {additionalInformation &&
        additionalInformation.map((info: string) => <TextListItem key={info}>{info}</TextListItem>)}
    </StyledTextList>
  </S.InformationWrapper>
);
